require('/ui/components/tabs/tabs.module.scss.module.css');

export const tabsHidden = "_tabs-hidden_ov0vv_1";
export const noMargin = "_no-margin_ov0vv_1";
